<p-card>
  <div class="row">
    <div class="col-12">
      <h1 class="mb-3">Administradores</h1>
      <p class="mb-3 text-color-secondary">
        Gestiona la información de los usuarios registrados en la página, incluyendo nombre completo, email, rol, estatus y fecha de creación, utiliza los filtros para acceder rápidamente a los datos necesarios.
      </p> 
    </div>
    <p-toast></p-toast>
  </div>
  <div class="row">
    <div class="col-12">
      <p-tabView styleClass="tabview-custom">
        <p-tabPanel>
          <ng-template pTemplate="header">
            <i class="fa-solid fa-building"></i>
            <span class="ml-2">Administradores</span>
          </ng-template>
          <app-admin-admins></app-admin-admins>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <i class="fa-solid fa-building"></i>
            <span class="ml-2">Roles</span>
          </ng-template>
          <app-admin-roles></app-admin-roles>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</p-card>
